"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.UnifiedState = void 0;var _authenticationTokens = require("./authenticationTokens");


class UnifiedState {
  /**
   * @type AuthenticationTokens
   */
  get currentAuthentication() {return _authenticationTokens.AuthenticationTokens.get();}

  /**
   * @type Object
   */


  clearAuthentication() {
    _authenticationTokens.AuthenticationTokens.clear();
    this.currentUser = undefined;
  }
}exports.UnifiedState = UnifiedState;